export const getLocation = () => {
  return window.location;
};

export const getDocument = () => {
  return window.document;
};
